import axios from 'axios';
import bookModal from './modal';

declare let booking_object: any;

export default class addBooking{ 

    private readonly apiUrl: string = booking_object.rest_urls.admin_add_booking;
    private readonly spinnerClass: string = 'bgdrop-spin';
    private form: HTMLFormElement | null;
    private button: HTMLButtonElement | null;
    private modal = new bookModal();
    private roomSelector: any = null;
    private gameSelector: any = null;
    private arenaIdSelector: any = null;
    private timeSelector: any = null;
    
    constructor(
        private elform: HTMLFormElement,
        private rooms: any,
        private games: any,
        private arenaId: any,
        private times: any,
        private buttonSelector: string
    ) {
            
        this.form = elform;
        this.roomSelector = rooms;
        this.gameSelector = games;
        this.arenaIdSelector = arenaId;
        this.timeSelector = times;
        this.button = document.querySelector<HTMLButtonElement>(buttonSelector);
        this.init();

    }

    /**
     * Initializes form validation and city selection.
     */
    private init(){
        
        if (!this.form) return;

        this.form.addEventListener('submit', async (e) => {
            
            e.preventDefault();
            await this.submitForm();

        });

    }

    /**
     * Handles form submission.
     */
    private async submitForm(){
        
        if (!this.form || !this.button) return;
        
        const formData = new FormData(this.form);
        const queryString = new URLSearchParams({ fields: new URLSearchParams(formData as any).toString() }).toString();

        this.button.disabled = true;
        const spinner = this.createSpinner();
        this.button.appendChild(spinner);

        try{
            
            const response = await axios.post(this.apiUrl, queryString, { validateStatus: (status) => status === 200 });
            document.body.insertAdjacentHTML('beforeend', response.data.message);
            if(response.data.status) this.handleSuccess();

        }catch (error: any){
            
            this.handleError(error);

        }finally{

            spinner.remove();
            this.button.disabled = false;

        }

    }

    /**
     * Handles a successful form submission.
     */
    private handleSuccess(){
        
        this.modal.get('successModal', 'closeSuccessModal');

        this.form?.reset();

        this.roomSelector.clear(true);
        this.gameSelector.clear(true);
        this.arenaIdSelector.clear(true);
        this.arenaIdSelector.clearOptions();
        this.arenaIdSelector.disable();
        this.timeSelector.clear(true);
        this.timeSelector.clearOptions();
        this.timeSelector.disable();

    }

    /**
     * Handles errors during form submission.
     */
    private handleError(error: any){

        if(error.response?.status === 201){

            document.body.insertAdjacentHTML('beforeend', error.response.data.message);
            this.modal.get('errorModal', 'closeErrorModal');

        }

    }

    /**
     * Creates a loading spinner element.
     */
    private createSpinner(): HTMLElement{

        const spinner = document.createElement('i');
        spinner.id = this.spinnerClass;
        spinner.className = 'fa-solid fa-circle-notch fa-spin ml-1 mt-1';
        return spinner;

    }

}